import { motion } from 'framer-motion'
import { Button } from '@mui/material'
import { ChevronRight } from 'lucide-react'
import { buttonStyle } from './styles' // Ensure the import path is correct

const GetEarlyAccessButton = ({ setShowLoginCard }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            // style={{ width: 'auto', justifyContent: isIOS || isMobile ? 'center' : 'flex-start', display: 'flex' }}
        >
            <Button 
                onClick={() => setShowLoginCard(true)} 
                sx={{
                    ...buttonStyle,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '48px', // Fixed height for consistency
                    lineHeight: 1
                }}
            >
                GET EARLY ACCESS
            </Button>
        </motion.div>
    )
}

export default GetEarlyAccessButton
